import React from 'react';
import {List, ListItem} from 'material-ui/List';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import Aa3_list from './Aa3Info.js';
import Grading from './grading3.js';

const App3 = () => (
  //This is holding the list of amino acid text fields
  
   <MuiThemeProvider >
    <List>
      <Aa3_list />
      </List>
</MuiThemeProvider>

);

export default App3;



// WEBPACK FOOTER //
// ./src/Aa3Code/App3.js